var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileNavWishList = function SvgMobileNavWishList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mobile-nav-wish-list_svg__a",
    d: "M0 0h44v44H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mobile-nav-wish-list_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mobile-nav-wish-list_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#mobile-nav-wish-list_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.301 10C32.674 10 36 14.08 36 19.57c0 4.261-3.86 8.627-11.882 13.9a3.3 3.3 0 0 1-3.586 0C12.51 28.196 9 23.83 9 19.57 9 13.577 12.355 10 17.16 10c1.94 0 3.257.642 5.07 2.099C24.046 10.642 25.36 10 27.302 10m.21 1.753c-1.348 0-2.286.473-3.806 1.716l-.584.48a1.09 1.09 0 0 1-1.36 0c-.115-.095-.513-.423-.584-.48-1.52-1.243-2.458-1.716-3.806-1.716-4.102 0-6.734 3.142-6.734 7.676 0 3.457 3.695 7.748 11.206 12.723.36.237.836.237 1.196 0 7.511-4.975 11.206-9.266 11.206-12.723 0-4.534-2.632-7.676-6.733-7.676"
  })))));
};
export default SvgMobileNavWishList;